import { cn } from '@/lib/utils'

/**
 * Aparência de um chip de filtro no painel.
 *
 * Existe uma `chipClass` parecida em components/public/FeatureFilters.tsx, mas aquela é
 * do site público: cores fixas (`bg-white`, `border-gray-200`) porque vive num header
 * translúcido claro. O painel tem tema escuro, então aqui a paleta é de tokens
 * semânticos — reaproveitar a de lá deixaria os chips brancos no dark mode.
 */
export function chipClass(active: boolean, className?: string) {
  return cn(
    // focus-visible: os chips são <button> crus, fora do shadcn; sem isto o Tab passa
    // por eles sem nenhum feedback visível.
    'inline-flex shrink-0 items-center gap-2 rounded-full border px-3 py-1.5 text-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
    active
      ? 'border-primary bg-primary/10 text-primary font-medium'
      : 'border-input text-muted-foreground hover:border-foreground/40 hover:text-foreground',
    className,
  )
}
